import { render, staticRenderFns } from "./TopArrow.vue?vue&type=template&id=a1350e8e"
import script from "./TopArrow.vue?vue&type=script&lang=js"
export * from "./TopArrow.vue?vue&type=script&lang=js"
import style0 from "./TopArrow.vue?vue&type=style&index=0&id=a1350e8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports